module.exports = __webpack_public_path__ + "static/img/albatard.819a326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/albatard.png
// module id = 25
// module chunks = 0